<template>
  <v-container>
    <div id="grid-adminDocs">
      <div v-if="loading">
        <loading></loading>
      </div>

      <v-layout justify-center>
        <v-flex xs12 md6>
          <v-text-field
            onkeydown="return event.key != 'Enter';"
            action="."
            method="get"
            v-model="search"
            append-icon="search"
            label="Digite nombre producto o palabra clave"
            single-line
            hide-details
            @input="getDataFull()"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout justify-center>
        <v-flex lg12>
          <v-data-table
            :headers="headers"
            :items="datosPaginados"
            :search="search"
            :page.sync="page"
            :rows-per-page-items="rowsPerPageItems"
            class="elevation-1"
            @page-count="pageCount = $event"
            hide-actions
          >
            <template v-slot:items="props">
              <tr v-if="props.item.estado">
                <!-- nombre y abre/cierra flechas titulo -->
                <td
                  v-if="props.item.estado"
                  :colspan="3"
                  class="font-weight-bold text-xs-left"
                >
                  {{ props.item.asunto }}
                  &nbsp;
                  <v-btn
                    v-if="
                      props.item.muestraFlecha &&
                      titulosAbiertos.includes(props.item.id)
                    "
                    outline
                    icon
                    dark
                    color="grey darken-2"
                    small
                    title="Ocultar sub items"
                    @click="handleRowClicked(props.item)"
                  >
                    <v-icon>arrow_drop_up</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="
                      props.item.muestraFlecha &&
                      !titulosAbiertos.includes(props.item.id)
                    "
                    outline
                    icon
                    dark
                    color="grey darken-1"
                    small
                    title="Desplegar sub items"
                    @click="handleRowClicked(props.item)"
                  >
                    <v-icon>arrow_drop_down</v-icon>
                  </v-btn>
                </td>
                <td v-if="props.item.estado" :colspan="2">&nbsp;</td>
                <td>
                  &nbsp;
                  <v-btn
                    v-if="
                      props.item.estado &&
                      usuarioLoggedTipe != 'PROVEEDOR' &&
                      getCodigoPerfil() != 'LEC'
                    "
                    depressed
                    tile
                    outline
                    icon
                    fab
                    dark
                    color="green darken-4"
                    small
                    title="Agregar documento"
                    @click="agregarDocumento(props.item.id)"
                  >
                    <v-icon>add</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="
                      (usuarioLoggedTipe == 'AGENCIA' ||
                      usuarioLoggedTipe == 'ADMINISTRADOR')
                      &&
                      getCodigoPerfil() != 'LEC'
                    "
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="red"
                    small
                    @click="
                      dialogDeleteSeccion(props.item.id, props.item.asunto)
                    "
                  >
                    <v-icon>clear</v-icon>
                  </v-btn>
                </td>
              </tr>
              <tr
                v-if="
                  !props.item.estado &&
                  titulosAbiertos.includes(props.item.idSuper)
                "
              >
                <!-- filas documentos, no titulo (sin flechas) -->
                <td v-if="!props.item.estado" class="text-xs-left">
                  {{ props.item.asunto }}
                </td>
                <td v-if="!props.item.estado" class="text-xs-left">
                  {{ props.item.descripcion }}
                </td>
                <td v-if="!props.item.estado" class="text-xs-left">
                  {{ filenameNew(props.item.filename) }}
                </td>
                <td v-if="!props.item.estado" class="text-xs-left">
                  {{ props.item.fechaCreacion }}
                </td>
                <td v-if="!props.item.estado" class="text-xs-left">
                  {{ props.item.usuario.username }}
                </td>
                <td v-if="!props.item.estado">
                  <v-btn
                    v-if="
                      props.item.filename != null &&
                      props.item.filename != '' &&
                      props.item.filename !== undefined
                    "
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="primary"
                    small
                    @click="downloadFile(props.item.id, props.item.filename)"
                  >
                    <v-icon>cloud_download</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="
                      (usuarioLoggedTipe == 'AGENCIA' ||
                      usuarioLoggedTipe == 'ADMINISTRADOR')
                      &&
                      getCodigoPerfil() != 'LEC'
                    "
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="red"
                    small
                    @click="dialogDeleteFile(props.item.id)"
                  >
                    <v-icon>clear</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
          <!-- LEYENDA TABLA ADMIN_DOCUMENTOS -->
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <div class="text-xs-center">
              <td>
                <template>
                  <v-btn
                  v-if="
                      (usuarioLoggedTipe == 'AGENCIA' ||
                      usuarioLoggedTipe == 'ADMINISTRADOR')
                      &&
                      getCodigoPerfil() != 'LEC'
                    "
                    depressed
                    tile
                    outline
                    icon
                    fab
                    dark
                    color="green darken-4"
                    small
                    title="Agregar documento"
                  >
                    <v-icon>add</v-icon> </v-btn
                  >&nbsp;Agregar documento
                  <v-btn
                    depressed
                    outline
                    title="Descargar documento"
                    icon
                    fab
                    dark
                    color="primary"
                    small
                  >
                    <v-icon>cloud_download</v-icon> </v-btn
                  >&nbsp;Descargar documento
                  <v-btn depressed outline icon fab dark color="red" small>
                    <v-icon>clear</v-icon> </v-btn
                  >&nbsp;Borrar documento
                </template>
              </td>
            </div> </v-card-actions
          ><v-flex xs12 sm6>
            <v-text-field
              value=""
              label="Total de Registros"
              v-model="cantRegistros"
              disabled
            ></v-text-field>
          </v-flex>
          <div class="text-center pt-2">
            <v-pagination
              @input="changePage(page)"
              v-model="page"
              :length="pageCount"
              :total-visible="9"
              circle
            >
            </v-pagination>
          </div>
        </v-flex>
      </v-layout>
      <v-dialog v-model="dialogLoading" persistent max-width="390">
        <loading-descarga></loading-descarga>
      </v-dialog>
      <!-- Dialog eliminar seccion-->
      <v-dialog v-model="dialogEliminarSeccion" persistent max-width="350">
        <v-card>
          <v-card-title class="headline">¿Está seguro?</v-card-title>
          <v-card-text
            ><b
              >¿Está seguro que desea eliminar esta sessión y todos los
              documentos que incluye?</b
            ></v-card-text
          >
          <v-card-text
            >Esta acción borrará definitivamente todos los documentos de la
            sección.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click="cerrarDeleteSeccion()"
              >Cancelar</v-btn
            >
            <v-btn color="green darken-1" flat @click="deleteSeccion()"
              >Aceptar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Dialog eliminar documento-->
      <v-dialog v-model="dialogEliminar" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">¿Está seguro?</v-card-title>
          <v-card-text
            ><b>¿Está seguro que desea eliminar ese archivo?</b></v-card-text
          >
          <v-card-text
            >Esta acción borrará definitivamente el documento.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click="dialogEliminar = false"
              >Cancelar</v-btn
            >
            <v-btn color="green darken-1" flat @click="deleteFile()"
              >Aceptar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Dialog documento-->
      <v-form ref="form" lazy-validation>
        <v-dialog v-model="dialogDoc" max-width="600">
          <v-card>
            <v-flex xs10 class="mx-4">
              <v-card-title class="headline" style="font-weight: bold"
                >Agregar Documento</v-card-title
              >
              <v-text-field
                v-model="asuntoDocumento"
                label="Asunto Documento"
                maxlength="100"
                :error-messages="asuntoErrors"
                @input="$v.asuntoDocumento.$touch()"
              ></v-text-field>
              <!-- ADJUNTOS -->
              <input
                v-if="tipeView != 'consulta'"
                type="file"
                id="visita-file"
                name="visitaFile"
                :accept="tipeArchive"
                color="primary"
                dark
                class="mb-2"
                @change="processFile"
                multiple
              /><v-text-field
                v-if="tipeView == 'oculto'"
                v-model="filenameValue"
                label="Filename"
                :box="(isDisabled = true)"
                :readonly="(isDisabled = true)"
                @input="$v.filename.$touch()"
                @blur="tipeView == 'crear' ? $v.filename.$touch() : null"
              ></v-text-field>
              <v-text-field
                v-if="tipeView == 'oculto'"
                v-model="idCalidadValue"
                label="id Calidad"
                :box="(isDisabled = true)"
                :readonly="(isDisabled = true)"
              ></v-text-field>
              <v-text-field
                v-if="tipeView == 'oculto'"
                v-model="base64Value"
                label="Encrypt"
                :box="(isDisabled = true)"
                :readonly="(isDisabled = true)"
                @input="$v.base64Value.$touch()"
                @blur="tipeView == 'crear' ? $v.base64Value.$touch() : null"
              ></v-text-field>
              <v-textarea
                v-model="descripcion"
                label="Descripción"
                maxlength="500"
                counter
              ></v-textarea>
              <v-card-actions class="pb-3">
                <v-spacer></v-spacer>
                <v-btn
                  color="indigo darken-1"
                  flat="flat"
                  @click="cerrarDialogDoc"
                  >Cancelar</v-btn
                >
                <v-btn color="success" dark class="mb-2" @click="saveDocument"
                  >Guardar</v-btn
                >
              </v-card-actions>
            </v-flex>
          </v-card>
        </v-dialog>
      </v-form>
    </div>
  </v-container>
</template>

<script>
import axios from "axios";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";
import Loading from "@/views/ui/Loading.vue";
import { misMixins } from "@/mixins/myMixing.js";
import Adjunto from "@/components/AdjuntoData.vue";
import jwtDecode from "jwt-decode";

export default {
  name: "grid-admistrativo",
  components: {
    LoadingDescarga,
    Adjunto,
    Loading,
  },
  mixins: [misMixins, validationMixin],
  props: {
    tipeView: String,
  },
  data() {
    return {
      //props.item.estado == true: titulo (mostrar flechas)
      //props.item.estado == false: documento (fila normal)
      idFile: "",
      dialogLoading: false,
      dialogEliminar: false,
      loading: false,
      dialog: false,
      dialogEliminarSeccion: false,
      idTitulo: "",
      rowsPerPageItems: [20],
      headers: [
        { text: "Asunto", sortable: false, value: "asunto" },
        {
          text: "Descripción",
          align: "left",
          sortable: false,
          value: "descripcion",
        },
        {
          text: "Documento",
          align: "left",
          sortable: false,
          value: "documento",
        },
        { text: "Fecha", sortable: false, value: "fecha" },
        { text: "Usuario", sortable: false, value: "usuario" },
        { text: "Acción", sortable: false, value: "" },
      ],
      administrativo: [],
      titulosAbiertos: [],
      search: "",
      page: 1,
      pageCount: 0,
      datosPaginados: [],
      paginaActual: 1,
      cantRegistros: 0,
      idTitulo: -1,
      asuntoTitulo: "",
      dialogDoc: false,
      asuntoDocumento: "",
      descripcion: "",
      adminAdjunto: 10,
      tipeArchive: ".pdf,.doc,.jpg,.png,.zip,.xls,.xlsx,.csv,.rar,.7z",
      base64Value: "",
      filenameValue: "",
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 6000);
    },
  },
  mounted() {
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.contratoId = this.$store.getters.contratoStored;
    this.proceso = this.$store.getters.proSelectedStored;
    if (
      this.contratoId == null ||
      this.contratoId == "" ||
      this.contratoId == undefined
    ) {
      this.contratoId = this.$route.params.contratoId;
    }
    this.loadDataAdministracion();
  },
  validations: {
    asuntoDocumento: { required },
  },
  computed: {
    asuntoErrors() {
      const errors = [];
      if (!this.$v.asuntoDocumento.$dirty) {
        return errors;
      }
      !this.$v.asuntoDocumento.required &&
        errors.push("Debe indicar el asunto.");
      return errors;
    },
  },
  methods: {
    getCodigoPerfil() {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const user = decoded.dto;
      // console.log("DEVODED USER:", user);
      return user.perfil.codigo;
    },

    async loadDataAdministracion() {
      this.limpiaTabla();
      this.alerta = false;
      this.loading = true;
      this.administrativo = await this.loadAdminAll();
      if (this.administrativo.length > 0) {
        var idSuper = -1;
        var nItems = this.administrativo.length;

        for (var i = 0; i < nItems; i++) {
          this.$set(this.administrativo[i], "_showDetails", true);
          if (this.administrativo[i].estado) {
            //titulo
            // this.titulosAbiertos.push(this.administrativo[i].id);
            idSuper = this.administrativo[i].id;
            this.$set(this.administrativo[i], "idSuper", -1);

            if (i < nItems - 1 && !this.administrativo[i + 1].estado) {
              //tiene al menos un hijo/subTitulo
              this.$set(this.administrativo[i], "muestraFlecha", true);
            } else {
              //NO tiene hijos/subTitulos
              this.$set(this.administrativo[i], "muestraFlecha", false);
            }
          } else {
            //fila documento
            this.$set(this.administrativo[i], "idSuper", idSuper);
            this.$set(this.administrativo[i], "muestraFlecha", false);
          }
        }

        this.cantRegistros = this.administrativo.length;
        this.pageCount = Math.ceil(
          this.administrativo.length / this.rowsPerPageItems
        );
        this.getDataPagina(this.page);
        this.alerta = false;
      } else {
        this.$parent.alerta = true;
        // console.log("vacios");
        this.limpiaTabla();
      }
      this.loading = false;
    },
    limpiaTabla() {
      // console.log("limpiaTabla");
      this.itemsProductos = [];
      this.datosPaginados = [];
      this.cantRegistros = 0;
      this.pageCount = 0;
      this.page = 1;
    },
    async loadAdminAll() {
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        idContrato: idContrato,
      };
      return await axios
        .post("/administracion/allDocuments", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    changePage(page) {
      this.page = page <= 0 || page > this.pages ? this.page : page;
      this.getDataPagina(this.page);
    },

    getDataPagina(noPagina) {
      this.paginaActual = noPagina;
      this.datosPaginados = [];

      let ini = noPagina * this.rowsPerPageItems - this.rowsPerPageItems;
      let fin = noPagina * this.rowsPerPageItems;
      this.datosPaginados = this.administrativo.slice(ini, fin);
    },
    getDataFull() {
      this.datosPaginados = [];
      this.page = 1;

      if (this.search.length > 0) {
        this.datosPaginados = this.administrativo.slice(
          0,
          this.administrativo.length
        );
      } else {
        this.getDataPagina(this.page);
      }
    },
    handleRowClicked(item) {
      if (!item.estado) {
        //solo para titulo/
        return;
      }

      const index = this.titulosAbiertos.indexOf(item.id);
      if (index > -1) {
        //cierra
        this.titulosAbiertos.splice(index, 1);

        for (var i = 0; i < this.datosPaginados.length; i++) {
          if (this.datosPaginados[i].idSuper == item.id) {
            this.$set(this.datosPaginados[i], "_showDetails", false);
          }
        }
      } else {
        //abre
        this.titulosAbiertos.push(item.id);
        for (var i = 0; i < this.datosPaginados.length; i++) {
          if (this.datosPaginados[i].idSuper == item.id) {
            this.$set(this.datosPaginados[i], "_showDetails", true);
          }
        }
      }
    },

    async downloadFile(id, filename) {
      this.dialogLoading = true;
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        fileName: filename,
        idContrato: idContrato,
        id: id,
      };
      return await axios
        .post("administracion/download", this.body, { responseType: "blob" })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          this.dialogLoading = false;
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    dialogDeleteSeccion(id, nombre) {
      this.dialogEliminarSeccion = true;
      this.idTitulo = id;
      this.asuntoTitulo = nombre;
    },
    cerrarDeleteSeccion() {
      this.dialogEliminarSeccion = false;
      this.idTitulo = -1;
      this.asuntoTitulo = "";
    },
    async deleteSeccion() {
      this.loading = true;
      this.body = {
        id: this.idTitulo,
        idContrato: this.$store.getters.contratoStored,
        nombre: this.asuntoTitulo,
      };

      axios
        .put("/administracion/deleteSeccion", this.body)
        .then((response) => {
          window.getApp.$emit("APP_DELETE");
          this.cerrarDeleteSeccion();
          this.loadDataAdministracion();
        })
        .catch((error) => {
          if (error) {
            this.dialogEliminarSeccion = false;
            if (error.response.data.message)
              window.getApp.$emit(
                "ERROR_EXCEPTION",
                error.response.data.message
              );
          }
        });
      this.loading = false;
    },
    dialogDeleteFile(id) {
      this.dialogEliminar = true;
      this.idFile = id;
    },
    async deleteFile() {
      this.body = {
        id: this.idFile,
        idContrato: this.$store.getters.contratoStored,
      };

      axios
        .put("/administracion/delete", this.body)
        .then((response) => {
          this.dialogEliminar = false;
          window.getApp.$emit("APP_DELETE");
          this.loadDataAdministracion();
        })
        .catch((response) => {
          this.dialogEliminar = false;
          if (error) {
            this.dialogEliminarSeccion = false;
            if (error.response.data.message)
              window.getApp.$emit(
                "ERROR_EXCEPTION",
                error.response.data.message
              );
          }
        });
      this.loading = false;
    },
    agregarDocumento(idTitulo) {
      this.dialogDoc = true;
      this.idTitulo = idTitulo;
    },
    cerrarDialogDoc() {
      this.dialogDoc = false;
      this.idTitulo = -1;
      this.asuntoDocumento = "";
      this.filenameValue = "";
      this.base64Value = "";
      this.descripcion = "";
    },
    saveDocument() {
      // console.log("this.asuntoDocumento:" +this.asuntoDocumento);
      // console.log("this.base64Value:" +this.base64Value);
      if (
        this.base64Value != null &&
        this.asuntoDocumento != null &&
        this.base64Value != "" &&
        this.asuntoDocumento != "" &&
        this.base64Value !== undefined &&
        this.asuntoDocumento !== undefined
      ) {
        let idContrato = this.$store.getters.contratoStored;
        let base64EncodedStr = this.base64Value;
        this.body = {
          idContrato: idContrato,
          idTitulo: this.idTitulo,
          asunto: this.asuntoDocumento,
          filename: this.filenameValue,
          documento: base64EncodedStr,
          descripcion: this.descripcion,
        };
        this.dialogDoc = false;
        axios
          .post("/administracion/save", this.body)
          .then((res) => {
            this.resp = res.data;
            window.getApp.$emit("APP_SAVE");
            this.cerrarDialogDoc();
            this.loadDataAdministracion();
          })
          .catch((error) => {
            if (error) {
              console.log(error);
              window.getApp.$emit(
                "ERROR_EXCEPTION",
                error.response.data.message
              );
            }
          });
      } else {
        window.getApp.$emit("DATOS_INCOMPLETOS");
      }
    },
    readFileAsync(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onloadend = (file) => {
          resolve(reader.result.split(",")[1]);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },

    async processFile(e) {
      try {
        let file = e.target.files[0];

        this.filenameValue = file.name;
        this.base64Value = await this.readFileAsync(file);
      } catch (err) {
        console.log("Error adjunto data:" + err);
      }
    },
  },
};
</script>